import React from 'react'
import styled from 'styled-components'
import { rem } from '../../styles/Mixins'
import { Container, Col, media } from 'styled-bootstrap-grid'
import { H6 } from '../../components/Typography'
import { Button } from '../../components'
import { PersonalNavSide } from '../../assets/svgs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'
import getImage from '../../utils/getImage'

const PersonalisedBoxSection = styled.section`
  position: relative;
  margin: ${rem(60)} 0 ${rem(48)};
  max-width: 1920px;

  /* stylelint-disable-next-line */
  ${media.xl`
    padding-top: ${rem(225, 'xxxl')};
    padding-bottom: ${rem(245, 'xxxl')};
    margin: 0 auto;
  `}

  /* stylelint-disable-next-line */
  ${(props) => props.theme.media.xxxl`
    padding-bottom: ${rem(250, 'xxxl')};
  `} :after {
    ${media.xl`
      background-image: url(${PersonalNavSide});
      content:"" ;
      display: block;
      position: absolute;
      top: 50%;
      right: -535px;
      transform: translateY(-50%);
      z-index: -1;
      width: 860px;
      height: 747px;
      background-size: contain;
    `}

    ${(props) => props.theme.media.xxxl`
      background-image: none;
      content: url(${PersonalNavSide});
      top: 51%;
      right: -473px;
      width: auto;
      height: auto;
    `}
  }

  ${Container} {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    ${media.xl`
      padding: 0;
      max-width: ${(props) =>
        props.theme.settings.container_horizontal_maxWidth_xl};
    `}

    ${media.xxl`
      max-width: ${(props) =>
        props.theme.settings.container_horizontal_maxWidth_xxl};
    `}

    @media (min-width: 1920px) {
      max-width: 1348px;
    }
  }
`

const BoxOverlayWrap = styled.div`
  /* display: none; */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  transition: 0.5s ease;
  opacity: 0;
  transform: translateY(35%);
`

const BoxOverlayContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  /* stylelint-disable-next-line */
  :after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    width: 100%;
    background-color: ${(props) => props.theme.colors.primary};
    opacity: 0.75;
    z-index: 1;
    border-radius: 50px;
  }
`

const BoxLink = styled.a`
  text-decoration: none;
  display: flex;

  ${media.lg`
    display: block;
  `}
`

const BoxOverlayButton = styled(Button)`
  z-index: 2;
  position: relative;
  padding: 10px;
  border-radius: 10px 0;
  outline: none;

  span {
    margin-left: 0;
  }

  :hover {
    opacity: 1;
    cursor: pointer;

    span {
      margin: auto !important;
    }
  }
`

const PersonalisedSectionTitle = styled(H6)`
  text-align: center;
  padding: 0 15px;
  margin: 0 auto ${rem(40)};
  width: 100%;

  ${media.xl`
    width: 770px;
    margin-bottom: ${rem(95, 'xxxl')};
  `}
`

const PersonalisedBox = styled.div`
  background-color: ${(props) => props.theme.colors.primary};
  border-radius: 15px 0;
  padding: 23px 50px 28px 20px;
  display: flex;
  flex: 1;
  transition: 0.5s ease;
  max-width: 500px;
  margin: 0 auto 5px;
  position: relative;

  ${media.md`
    margin-right: 5px;
    max-width: 100%;
  `}

  ${media.lg`
    border-radius: 0;
    text-align: center;
    background-color: transparent;
    display: block;
    width: 100%;
    padding: 40px 30px;

    &:hover ${BoxOverlayWrap} {
      /* display: block; */
      opacity: 1;
      transform: translateY(0);
    }
  `}

  ${media.xl`
    padding: 40px 35px;
  `}

  @media (min-width: 1920px) {
    padding: 50px 50px;
  }

  img {
    width: 30px;
    height: 30px;

    ${media.sm`
      width: 45px;
      height: 45px;
    `}

    ${media.lg`
      margin-bottom: 20px;
    `}

    @media (min-width: 1920px) {
      width: auto;
      height: auto;
      margin-bottom: 30px;
    }
  }
`

const PersonalisedBoxTextDescription = styled.p`
  font-family: 'foco_cc_bold', sans-serif;
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  margin: 0;

  ${media.md`
    min-height: 45px;
  `}

  ${media.xl`
    font-size: ${rem(22, 'xxxl')};
    line-height: ${rem(32, 'xxxl')};
  `}
`

const PersonalisedBoxYellowText = styled.p`
  /* stylelint-disable-next-line */
  font-family: 'foco_cc_bold_italic';
  color: ${(props) => props.theme.colors.secondary_dark};
  font-weight: 700;
  font-size: ${rem(16)};
  margin: 13px 0 0;

  ${media.xl`
    font-size: ${rem(22, 'xxxl')};
    margin: 35px 0 0;
  `}
`

const PersonalisedBoxRow = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;

  ${media.lg`
    border-radius: 25px 0 25px 0;
    background-color: ${(props) => props.theme.colors.primary};
    overflow: hidden;
    width: auto;
  `}

  /* stylelint-disable-next-line */
  @media screen and (min-width:0\0) {
    width: 100%;
  }

  &.col-4 {
    > div {
      ${media.lg`
        min-width: 25%;
      `}
    }
  }

  &.col-3 {
    > div {
      ${media.lg`
        min-width: 33.33%;
      `}
    }
  }

  &.col-2 {
    @media screen and (min-width: 0\0) {
      width: 70%;
    }

    > div {
      ${media.lg`
        min-width: 50%;
      `}
    }
  }

  &.col-1 {
    width: 100%;
    justify-content: center;

    ${media.lg`
      width: auto;
    `}

    @media screen and (min-width: 0\0) {
      width: 33.33%;
    }

    > div {
      ${media.lg`
        min-width: 100%;
      `}
    }
  }
`

const PersonalisedBoxCol = styled.div`
  display: flex;
  min-width: 100%;
  position: relative;
  flex: 1;

  ${media.md`
    min-width: 50%;
    max-width: 50%;
  `}

  ${media.lg`
    :after {
    content: '';
    position: absolute;
    height: 100%;
    right: 0;
    top: 0;
    opacity: 0.15;
    width: 4px;
    background-color: #fff;
    }

    :last-child:after {
      display: none;
    }
  `}
`

const PersonalisedBoxText = styled.div`
  color: ${(props) => props.theme.colors.white};
  padding-left: 25px;

  ${media.lg`
    padding-left: 0;
  `}

  strong {
    /* stylelint-disable-next-line */
    font-family: 'foco_cc_black';

    em {
      /* stylelint-disable-next-line */
      font-family: 'foco_cc_black_italic';
    }
  }

  /* stylelint-disable-next-line */
  em {
    /* stylelint-disable-next-line */
    font-family: 'foco_cc_italic';

    strong {
      /* stylelint-disable-next-line */
      font-family: 'foco_cc_black_italic';
    }
  }
`

const PersonalisedBoxArrow = styled.div`
  color: ${(props) => props.theme.colors.primary_light};
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);

  ${media.lg`
    display: none;
  `}
`

const PersonalisedNav = (props) => {
  return (
    <PersonalisedBoxSection>
      <Container>
        <Col col="12">
          <PersonalisedSectionTitle>{props?.title}</PersonalisedSectionTitle>
        </Col>
        <PersonalisedBoxRow className={`col-` + props?.cards?.length}>
          {props?.cards?.map((box) => {
            return (
              <PersonalisedBoxCol key={`boxcol${box?.cardTitle}`}>
                <PersonalisedBox>
                  <BoxLink href={box?.cardLink?.uri ? box.cardLink.uri : null}>
                    {box?.cardIcon?.localFile ? (
                      <img
                        src={getImage(box?.cardIcon?.localFile, 'fluid')}
                        alt=""
                      />
                    ) : null}
                    <PersonalisedBoxText>
                      <PersonalisedBoxTextDescription>
                        {box?.cardTitle}
                      </PersonalisedBoxTextDescription>
                      <PersonalisedBoxYellowText>
                        {box?.cardSubtitle}
                      </PersonalisedBoxYellowText>
                    </PersonalisedBoxText>
                    {box?.cardLink && (
                      <>
                        <PersonalisedBoxArrow>
                          <FontAwesomeIcon icon={faChevronRight} />
                        </PersonalisedBoxArrow>

                        <BoxOverlayWrap>
                          <BoxOverlayContent>
                            <BoxOverlayButton label={box?.cardTitle}></BoxOverlayButton>
                          </BoxOverlayContent>
                        </BoxOverlayWrap>
                      </>
                    )}
                  </BoxLink>
                </PersonalisedBox>
              </PersonalisedBoxCol>
            )
          })}
        </PersonalisedBoxRow>
      </Container>
    </PersonalisedBoxSection>
  )
}

export default withNullErrorBoundary(PersonalisedNav)
